import { type MouseEvent as ReactMouseEvent } from 'react';
import { useNavigate } from 'react-router';
import BulbIcon from '~/images/icons/BulbIcon';
import { OutlineChevronDownIcon, OutlinePencilIcon } from '@tempmee/react-icons';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Colors } from '~/themes/colors';
import { Center } from '../Center';
import { Column } from '../Column';
import { Row } from '../Row';

interface IBackTipsProps {
  date: Date;
  onReturnClick(e: ReactMouseEvent<HTMLDivElement>): void;
}

export const BackTips = ({ date, onReturnClick }: IBackTipsProps) => {
  const navigate = useNavigate();

  const handleEditClick = () =>
    navigate('/dashboard/multi-day/edit', {
      state: { editedDate: date, defaultOpenCardIndex: 'rate' },
    });

  return (
    <Column backgroundColor={Colors.secondary_25} borderRadius={8} height="100%" width="100%">
      <Row
        alignItems="center"
        justifyContent="space-between"
        paddingBottom={12}
        paddingInline={16}
        paddingTop={18}
      >
        <Row
          alignItems="center"
          justifyContent="space-between"
          borderBottomWidth={1}
          borderBottomStyle="solid"
          borderBottomColor={colors.neutral[100]}
          paddingBottom={6}
          paddingRight={12}
          width="100%"
        >
          <Row alignItems="center" cursor="pointer" onClick={onReturnClick}>
            <Center transform="rotate(90deg)">
              <OutlineChevronDownIcon size={24} color={colors.secondary[500]} />
            </Center>
            <Typography
              as="span"
              bold
              color={colors.secondary[500]}
              size="body_large"
              style={{ marginLeft: 10, textTransform: 'capitalize' }}
            >
              Return
            </Typography>
          </Row>
          <Row alignItems="center" gap={4}>
            <BulbIcon color={colors.secondary[500]} />
            <Typography as="span" bold color={colors.primary[500]} size="body_large" style={{ marginTop: 4 }}>
              Tips!
            </Typography>
          </Row>
        </Row>
      </Row>

      <Column paddingRight={20} paddingLeft={24} gap={2}>
        <Typography as="span" style={{ marginTop: 2 }}>
          Boost your chances of filling this shift! We recommend increasing the hourly rate beyond
          the industry average on shifts posted within <strong>36 hours</strong> from its starting
          time.
          <br />
          Click "Edit" to bump the rate higher.
        </Typography>
      </Column>

      <Row
        bottom={24}
        cursor="pointer"
        gap={4}
        position="absolute"
        right={32}
        onClick={handleEditClick}
      >
        <OutlinePencilIcon color={colors.secondary[500]} />
        <Typography as="span" color={colors.secondary[500]} size="body_large">
          Edit
        </Typography>
      </Row>
    </Column>
  );
};
